// Copyright (C) 2013 Minted Inc.
// All Rights Reserved

M.View = M.View || {};
M.View.ProductDetails = M.View.ProductDetails || {};

/**
 * @class ZoomDialog
 */
M.View.ProductDetails.ZoomDialog = Backbone.View.extend({

  template: _.template(M.Template.ProductDetails.ZoomDialog),

  initialize: function() {
    _.bindAll(
      this, 'render', '_preSelectActiveAccessoryOption');

    this.isDialogCreated = false;

    // Listen for the click event that triggers this dialog
    var that = this;
    $(this.options.triggerIdentifier).click(function() {
      that.render();
    });

    this.$el = $(this.el);
  },

  render: function() {
    var that = this;
    this.$el.empty();

    var templateVars = {
      model: this.model,
      imageUrl: this._getImgUrl()
    };

    this.html = this.template(templateVars);
    this.$el.append(this.html);

    // Color options picker
    if (this.model.get('colorOptions').length > 0) {
      // TODO: Merge ArtColorPicker with ColorPicker
      this.colorPicker = new M.View.ProductDetails.ColorPicker({
        collection: this.model.get('colorOptions')
      });
      this.$el.find('.colorPicker').replaceWith(
        this.colorPicker.render().el
      );

      this.colorPicker.bind('color_changed', function(previousColor) {
        var selectedSwatch = this.collection.getSelected();
        that.model.get('productImage').set({
          'colorCode': selectedSwatch.get('letter')
        });
        that._updateProductImage();

        // Track colorway click event
        var isDefault = !!selectedSwatch.get('default_choice');
        // Selected index parameter should be 1-based
        var selectedIdx = this.collection.indexOf(selectedSwatch) + 1;
        that.trackColorwayClick(
          that.model.get('parentSku'), selectedIdx, selectedSwatch.get('name'),
          isDefault, previousColor.get('name')
        );
      });

    }

    // Shape options picker
    if (this.model.get('shapeOptions').length > 0) {
      this.shapePicker = new M.View.ProductDetails.ShapePicker({
        collection: this.model.get('shapeOptions'),
        selectedDieCutCode: this.model.get('selectedDieCutCode')
      });

      this.$el.find('.shapePicker').replaceWith(
        this.shapePicker.render().el
      );

      this.shapePicker.bind('shape_option_clicked', function(previousShape) {
        var selectedShape = this.collection.getSelected();
        var sku = that.model.get('parentSku');
        that.model.get('productImage').set({
          'dieCutCode': selectedShape.get('code'),
          'sku': sku,
          'viewCode': M.PRODUCT_IMAGE.VIEW_CODE.FRONT_COMPOSITE
        });
        that._updateProductImage();

        // Deselect active accessory options
        that.tryDeselectAccessory();

        // Auto select the first, "front" view option
        that.photoViewPicker.selectFirst();

        // Track Shape Option Click Event
        var isDefaultShape = (selectedShape.get('name') === that.model.get('defaultDieCutShape'));
        // Selected index parameter should be 1-based
        var selectedIdx = this.collection.indexOf(selectedShape) + 1;
        that.trackShapeClick(sku, previousShape, selectedShape, isDefaultShape, selectedIdx);
      });
    }

    // Photo views picker
    if (this.model.get('photoViewOptions').length > 0) {
      this.photoViewPicker = new M.View.ProductDetails.PhotoViewPicker({
        collection: this.model.get('photoViewOptions')
      });
      this.$el.find('.photoViewPicker').replaceWith(
        this.photoViewPicker.render().el
      );

      this.photoViewPicker.selectFirst();

      this.photoViewPicker.bind('photo_view_option_clicked', function() {
        var selectedPhotoView = this.collection.getSelected();
        that.model.get('productImage').set({
          'dieCutCode': null,
          'sku': that.model.get('parentSku'),
          'viewCode': selectedPhotoView.get('code')
        });
        that._updateProductImage();

        // Deselect active accessory options
        that.tryDeselectAccessory();

        // Auto select the square/flat shape option
        // (we can't display die cuts and alternate views simultaneously).
        if (that.model.get('shapeOptions').length > 0) {
          that.shapePicker.selectFirst();
        }
      });
    }

    // Greeting picker
    if (this.model.get('greetingOptions').length > 0) {
      this.greetingPicker = new M.View.ProductDetails.GreetingPicker({
        collection: this.model.get('greetingOptions')
      });
      this.$el.find('.greetingPicker').replaceWith(
        this.greetingPicker.render().el
      );

      var selectedGreetingId = this.model.get('selectedGreetingId');
      if (selectedGreetingId) {
        this.greetingPicker.selectById(selectedGreetingId);
      } else {
        this.greetingPicker.selectFirst();
      }

      this.greetingPicker.bind(
          'greeting_option_clicked', function(previousGreeting) {

        var selectedGreeting = this.collection.getSelected();
        var sku = that.model.get('parentSku');

        that.model.get('productImage').set({
          'sku': sku,
          'viewCode': M.PRODUCT_IMAGE.VIEW_CODE.FRONT_COMPOSITE,
          'greetingIndex': selectedGreeting.get('id'),
          'greeting': selectedGreeting.get('displayName')
        });

        that._updateProductImage();

        // Deselect active accessory options
        that.tryDeselectAccessory();

        // Log greeting click event
        that.trackGreetingClick(sku, previousGreeting, selectedGreeting);
      });
    }

    // Accessory options picker (matching items)
    if (this.model.get('accessoryOptions').length > 0) {
      this.accessoryQuantityPickers = {};

      this.accessoryPicker = new M.View.ProductDetails.AccessoryPicker({
        collection: this.model.get('accessoryOptions')
      });

      this.$el.find('.accessoryPicker').replaceWith(
        this.accessoryPicker.render().el
      );

      this.accessoryPicker.bind('accessory_option_clicked', function() {
        var selectedAccessory = that.accessoryPicker.collection.getSelected();
        that._showSelectedAccessoryQuantityPicker(selectedAccessory);

        that.$el.find('.addToOrder .caption').hide();

        that.model.get('productImage').set({
          'dieCutCode': null,
          'sku': selectedAccessory.get('sku'),
          'viewCode': M.PRODUCT_IMAGE.VIEW_CODE.FRONT_COMPOSITE
        });
        that._updateProductImage();

        // Auto select the front of the square/flat card
        // (we can't display die cuts and accessories simultaneously).
        that.shapePicker.selectFirst();
        that.photoViewPicker.deSelect();
      });

      // A single quantity picker will be rendered at the bottom of the dialog
      // when one of the accessory options is selected.
      _.each(this.model.get('accessoriesPricingDict'),
        function(accessoryOptionsPricing, accessorySku) {
          var accessoryQuantityPicker = new M.View.ProductDetails.QuantityPicker({
            model: accessoryOptionsPricing
          });

          // Append each quantityPicker to the placeholder div and hide by default.
          // They will be exposed one at a time when each accessory option is selected
          that.$el.find('.quantityPickers').append(
            accessoryQuantityPicker.render().el
          );
          accessoryQuantityPicker.$el.hide();

          accessoryQuantityPicker.bind('quantitySelected', function(quantity) {
            accessoryOptionsPricing.set({'quantity': quantity});

            // Expose the "Added to your order" message to make it more obvious
            // to the user that they are modifying their order's accessory
            // quantity from the dialog.
            if (quantity > 0) {
              that.$el.find('.addToOrder .caption').show();
            } else {
              that.$el.find('.addToOrder .caption').hide();
            }

            // The PDP options panel iframe window is listening for this event
            // through the parent window. This is necessary to keep the zoom
            // dialog accessory quantity pickers in sync with the options panel.
            // TODO: remove once the PDP has been fully ported to python.
            that.trigger('accessory_quantity_changed_zoom_dialog',
              accessoryOptionsPricing);
          });

          that.accessoryQuantityPickers[accessorySku] = accessoryQuantityPicker;
        }
      );

    } // end Accessory options

    // Hide the add to order and buy button unless an
    // accessory option is checked
    this._hideAccessoryControls();

    // Initialize the jQueryUI dialog
    if (!this.isDialogCreated) {
      this.isDialogCreated = true;
      this.$el.dialog({
        autoOpen: false,
        dialogClass: 'zoomDialog',
        draggable: false,
        modal: true,
        resizable: false,
        title: this.model.get('title'),
        width: 886,
        zIndex: 2000,
        open: that._preSelectActiveAccessoryOption,
        close: function() {
          // TODO: cleanup views
        }
      });
    }

    this.$el.dialog('open');
  },

   /**
   * Calls the track API, logging the previous and currently selected shape
   */
  trackShapeClick: function(
      sku, previousShape, selectedShape, isDefaultShape, selectedIdx) {
    var previousShapeDisplayName = null;

    if (previousShape) {
      previousShapeDisplayName = previousShape.get('name');
    }

    M.sendTrackAPI({
      'feature': M.GA.TRACK_EVENT_CATEGORY.PDP,
      'event': M.GA.TRACK_EVENT_ACTION.ZOOM_DIALOG_SHAPE_CLICK,
      'sku': sku,
      'from_shape': previousShapeDisplayName,
      'to_shape': selectedShape.get('name'),
      'to_shape_position': selectedIdx,
      'is_to_shape_default': isDefaultShape
    });
  },

  /**
   * Calls the track API, logging the previous and currently selected greeting.
   */
  trackGreetingClick: function(sku, previousGreeting, selectedGreeting) {
    var previousGreetingDisplayName = null;
    if (previousGreeting) {
      previousGreetingDisplayName = previousGreeting.get('displayName');
    }
    M.sendTrackAPI({
      'feature': M.GA.TRACK_EVENT_CATEGORY.PDP,
      'event': M.GA.TRACK_EVENT_ACTION.ZOOM_DIALOG_ALT_GREETING_CLICK,
      'sku': sku,
      'from_greeting': encodeURIComponent(previousGreetingDisplayName),
      'to_greeting': encodeURIComponent(selectedGreeting.get('displayName'))
    });
  },

  tryDeselectAccessory: function() {
    // Deselect active accessory options
    if (this.model.get('accessoryOptions').length > 0) {
      this.accessoryPicker.deSelect();
      this._hideAccessoryControls();
    }
  },

  /**
   * Logs colorway icon click event.
   */
  trackColorwayClick: function(
      sku, colorIdx, colorName, isDefault, previousColorName) {
    M.sendTrackAPI({
      'feature': M.GA.TRACK_EVENT_CATEGORY.PDP,
      'event': M.GA.TRACK_EVENT_ACTION.ZOOM_DIALOG_COLORWAY_CLICK,
      'sku': sku,
      'to_color_name': colorName,
      'is_to_color_default': isDefault,
      'to_color_position': colorIdx,
      'from_color_name': previousColorName
    });
  },

  /**
   * Visually select the active accessory if the dialog was triggered
   * from one of the accessory (aka "matching item") thumbnails.
   */
  _preSelectActiveAccessoryOption: function() {
    var selectedSku = this.model.get('sku');
    if (_.contains(this.model.getAccessorySkus(), selectedSku)) {
      var selected = this.accessoryPicker.collection.selectBySku(selectedSku);
      this._showSelectedAccessoryQuantityPicker(selected);
      this.model.get('productImage').set({'sku': selectedSku});
      this._updateProductImage();
    }
  },

  /**
   * Hides accessory related elements.
   */
   _hideAccessoryControls: function() {
      var $buyButton = this.$el.find('.buttonBuySeparately');
      var $addToOrder = this.$el.find('.addToOrder');
      $buyButton.css({'visibility': 'hidden'});
      $addToOrder.css({'visibility': 'hidden'});
   },

   /**
    * Hides the accessory quantity pickers only.
    */
    _hideAccessoryQuantityPickers: function() {
      _.each(this.accessoryQuantityPickers, function(quantityPicker) {
        quantityPicker.$el.hide();
      });
    },

  /**
   * Exposes the quantity picker and related UI elements for
   * the selected Accessory.
   *
   * @param selectedAccessory {M.Model.ProductDetails.Accessory}
   */
  _showSelectedAccessoryQuantityPicker: function(selectedAccessory) {
    // Update buy button url, display button if accessory option is clicked.
    var $buyButton = this.$el.find('.buttonBuySeparately');
    $buyButton.css({'visibility': 'visible'});
    $buyButton.attr('href', selectedAccessory.get('url'));

    // Display the quantity picker container
    var $addToOrder = this.$el.find('.addToOrder');
    $addToOrder.css({'visibility': 'visible'});
    $addToOrder.show();

    // Hide accessory quantity pickers, and expose the picker
    // for the selected accessory option.
    this._hideAccessoryQuantityPickers();
    var selectedAccessoryQuantityPicker = this.accessoryQuantityPickers[
      selectedAccessory.get('sku')];
    selectedAccessoryQuantityPicker.$el.show();
  },

  /**
   * Returns the zoom image url based on the selected options
   */
  _getImgUrl: function() {
    var productImage = this.model.get('productImage');
    return productImage.getImgUrl();
  },

  /**
   * Replaces the product image url based on the selected options.
   */
  _updateProductImage: function() {
    var url = this._getImgUrl();
    this.$el.find('.productPhoto').attr('src', url);
  },

  updateMoreViewForJournal: function(formatId) {
    if (M.SKU.isNotebook(this.model.get('sku'))) {
      var journalViewList = M.ProductDetails.getViewOptionsForJournal(formatId);

      // update the preview image to the first one
      this.model.get('productImage').set({
        viewCode: journalViewList[0].file_photo_code
      });

      this._updateProductImage();

      var newPhotoViewData = [];
      _(journalViewList).each(function(viewOption) {
        if (viewOption.file_photo_code) {
          newPhotoViewData.push(viewOption);
        }
      });

      this.model.updatePhotoViewOptions(newPhotoViewData);
    }
  }
});
